import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_brands_list: { message: "idle" },
};

export const retrieve_brands_list_Slice = createSlice({
 name: "retrieve_brands_list",
 initialState,
 reducers: {
  success_retrieve_brands_list: (state, action) => {
   state.retrieve_brands_list = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_brands_list: (state, action) => {
   state.retrieve_brands_list = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_brands_list: (state) => {
   state.retrieve_brands_list = { status: app_consts.IDLE };
  },
  loading_retrieve_brands_list: (state) => {
   state.retrieve_brands_list = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_brands_list, fail_retrieve_brands_list, reset_retrieve_brands_list, loading_retrieve_brands_list } = retrieve_brands_list_Slice.actions;

export default retrieve_brands_list_Slice.reducer;